export default function auth({ next, router }) {
  if (!localStorage.getItem('token_expires_at')) {
    localStorage.removeItem('token')
    return router.push({ name: 'CompanyLogin' })
  } else {
    const tokenExpiration = new Date(localStorage.getItem('token_expires_at'))
    const currentTimestamp = new Date()
    if (currentTimestamp >= tokenExpiration) {
      localStorage.removeItem('token')
      localStorage.removeItem('token_expires_at')
      return router.push({ name: 'CompanyLogin' })
    }
  }

  if (!localStorage.getItem('token')) {
    return router.push({ name: 'CompanyLogin' })
  }

  return next()
}
